import { useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const ST = { update: ["Da aggiornare", "bg-emerald-50 text-emerald-800"], same: ["Già presente", "bg-slate-100 text-slate-600"], error: ["Saltata", "bg-red-100 text-red-800"] };

export const WorkEmailImport = ({ onDone }) => {
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(false);
  const send = async (path) => { const fd = new FormData(); fd.append("file", file); return api.post(`/employees/work-emails/${path}`, fd); };
  const preview = async () => { setBusy(true); try { setRows((await send("preview")).data); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); } };
  const commit = async () => {
    setBusy(true);
    try { const r = (await send("commit")).data; toast.success(`${r.updated} email aziendali salvate${r.accounts_updated ? `, ${r.accounts_updated} accessi app aggiornati` : ""}`); setOpen(false); setRows(null); setFile(null); onDone(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const n = (s) => (rows || []).filter((r) => r.status === s).length;
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} data-testid="work-email-import-button"><Upload className="mr-1 h-4 w-4" />Importa email aziendali</Button>
      <Dialog open={open} onOpenChange={(o) => { if (!o && !busy) { setOpen(false); setRows(null); } }}>
        <DialogContent className="max-h-[90vh] max-w-4xl overflow-y-auto" data-testid="work-email-import-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl">Importa email aziendali da Excel</DialogTitle></DialogHeader>
          <p className="text-sm text-muted-foreground">Colonne: Società, Matricola, Codice Fiscale, email aziendale. Il dipendente viene riconosciuto dal codice fiscale (o dalla matricola) nella società indicata. Se ha già un accesso all'app, anche quello passa alla nuova email.</p>
          <div className="flex gap-2"><Input type="file" accept=".xlsx" onChange={(e) => { setFile(e.target.files[0] || null); setRows(null); }} data-testid="work-email-import-file" />
            <Button onClick={preview} disabled={!file || busy} data-testid="work-email-import-preview">Anteprima</Button></div>
          {rows && <>
            <div className="text-sm" data-testid="work-email-import-summary"><b>{n("update")}</b> da aggiornare · {n("same")} già presenti · <span className="text-red-700">{n("error")} saltate</span></div>
            <div className="max-h-[45vh] overflow-y-auto border">
              {rows.map((r) => (
                <div key={r.row} className="grid grid-cols-[50px_1fr_1.2fr_110px] items-center gap-2 border-b px-3 py-1.5 text-xs" data-testid={`work-email-row-${r.row}`}>
                  <span className="font-mono text-muted-foreground">r.{r.row}</span>
                  <span><b>{r.name || r.tax_code}</b> <span className="text-muted-foreground">{r.company}</span></span>
                  <span className="font-mono">{r.email}{r.message && <div className={`font-sans text-[11px] ${r.status === "error" ? "text-red-700" : "text-muted-foreground"}`}>{r.message}</div>}</span>
                  <span className={`px-1.5 py-0.5 text-center text-[10px] font-semibold uppercase ${ST[r.status][1]}`}>{ST[r.status][0]}</span>
                </div>
              ))}
            </div>
          </>}
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} disabled={busy}>Annulla</Button>
            <Button onClick={commit} disabled={busy || !rows || !n("update")} data-testid="work-email-import-commit">Importa {rows ? n("update") : ""}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
